var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn",class:{'active': _vm.isActive},attrs:{"disabled":_vm.isDisable},on:{"click":function($event){return _vm.$emit('click')}}},[_c('p',{staticClass:"text-caption"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }